import { tracking } from '@iwoca/frontend-tracking-library';
import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.context';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { getDateRangeLabel } from 'components/DashboardSettings/DateRangeFilter/DateRangeFilter.helper';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';

const CTA_TYPE = 'Results bar';

export const useResultsBar = () => {
  const { table, dateRange } = useApplicationsTableState();
  const { isLoading, isError, state, setIsSettingsOpen } = useDashboard();

  const hasColumnFilters = table.getState().columnFilters.length > 0;

  const openDateRangeSettings = () => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Date range',
      'CTA type': CTA_TYPE,
    });
    setIsSettingsOpen(true);
  };

  const clearFilters = () => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Clear filters',
      'CTA type': CTA_TYPE,
    });
    table.resetColumnFilters();
  };

  return {
    isLoading: !isError && (isLoading || state.applications === undefined),
    dateRangeLabel: getDateRangeLabel(dateRange),
    applicationCount: table.getFilteredRowModel().rows.length,
    hasActiveQuery: hasColumnFilters || Boolean(state.searchString),
    canClearFilters: hasColumnFilters,
    openDateRangeSettings,
    clearFilters,
  };
};
